var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",class:{ 'animatied-skeleton': _vm.animation && !_vm.skeletonItem.subChild, 'top-level' : _vm.toplevel },style:(_vm.getStyle)},_vm._l((_vm.skeletonItem.subChild),function(item,index){return _c('skeleton',{key:index,attrs:{"skeletonItem":item,"toplevel":false,"animation":_vm.animation}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }